import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
// import p1 from 'assests/Photos/Clubs/CommerceClub/Mockstock/1.jpg';
// import p2 from 'assests/Photos/Clubs/CommerceClub/Mockstock/2.jpg';
// import p3 from 'assests/Photos/Clubs/CommerceClub/Mockstock/3.jpg';
// import p4 from 'assests/Photos/Clubs/CommerceClub/Mockstock/4.jpg';
// import p5 from 'assests/Photos/Clubs/CommerceClub/Mockstock/5.jpg';
// import p6 from 'assests/Photos/Clubs/CommerceClub/Mockstock/6.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import SideBarAssoc2025 from '../CommerceAssociation2023/components/SideBarAssoc2023/SideBarAssoc2025';
import Archive2023 from '../CommerceAssociation2023/Archive2023';

const MockStock2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/association/CommerceClub/Mockstock/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/association/CommerceClub/Mockstock/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/association/CommerceClub/Mockstock/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/association/CommerceClub/Mockstock/4.webp`;
    
  

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        }, 
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },  
        
    ];

    return (
        <Main>

            <Container>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
                                <Typography variant='h5' align='center' >
                                MOCK STOCK
                                </Typography>
                              
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: 9 - 12 &  Date: 8 July 2025
                                </Typography>
                                <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                              ><br />
                               “The most important quality for an investor is temperament, not intellect." - Warren Buffett
                                <br /><br />
                            </Typography>
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The Commerce Association of National Public School, Yeshwanthpur, arranged an educational event called ‘Mock Stock’ for students from Classes 9 to12 on Tuesday, July 8.The event combined strategy, competition and practical learning to replicate the thrill of stock market trading without actual money.
                                <br/>
                                A written test on stock market fundamentals was given at the start of the event to gauge the students' comprehension of trading principles and investment logic. Students who qualified advanced to the main stage. They were challenged to react strategically and modify their trading decisions in response to the crisis scenarios that were introduced in each round. Participants used competitive bidding to build their portfolios during a live auction of shares. Two intense trading rounds ensued, during which they engaged in real-time share purchases and sales.
                               <br/>
                                Mock Stock was an enriching event for students to explore the dynamics of the market and its related risk and apply their commerce learning in realistic simulation. 
                                <br/>
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                              ><br />
                                "The individual investor should act consistently as an investor and not as a speculator." — Ben Graham
                                <br />
                            </Typography> */}
                            </Box>
                            
                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 400}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                              <SideBarAssoc2025/>
                        </Box>
                        <Box marginBottom={4}>
                        <Archive2023 />
                        </Box>
                      
                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default MockStock2025;